export enum NotificationMethod {
  NONE,
  EMAIL_ONLY,
  SMS_ONLY,
  EMAIL_AND_SMS,
}

export namespace NotificationMethod {
  let elements = [
    NotificationMethod.NONE,
    NotificationMethod.EMAIL_ONLY,
    NotificationMethod.SMS_ONLY,
    NotificationMethod.EMAIL_AND_SMS,
  ];
  let alias = "com.bcdfx.model.NotificationMethod";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
